import { animated } from '@react-spring/web';
import styled, { css } from 'styled-components';
import { calculateSafeColorInsideContainer } from '@abbiamo/seller-theme-utils';

export const Container = styled(animated.div)`
  background-color: ${(p) => p.theme.seller.primary.value};
  height: 100%;
  overflow: hidden;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 30;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 0.75rem;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-left: 1rem;
`;

export const Divider = styled.div`
  margin: 1rem 1rem;
  width: calc(100% - 2rem);
  height: 1px;
  background-color: ${(p) => p.theme.seller.primary.safeColorInsideContainer};
`;

const FocusedMenuItemCss = css`
  background-color: rgba(0, 0, 0, 0.3);
`;

export const MenuItem = styled.button<{ $focused?: boolean }>`
  width: 100%;
  padding: 0.8rem 0.8rem;
  margin: 0;

  background-color: transparent;
  border: none;

  color: ${(p) => p.theme.seller.primary.safeColorInsideContainer};

  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;

  border-radius: 0.5rem;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  ${(p) => p.$focused && FocusedMenuItemCss}
`;

export const MenuItemText = styled.p`
  font-size: 1.6rem;
  white-space: nowrap;
  text-align: left;
  padding-left: 1rem;
  margin: 0;
  flex: 1;
`;

export const MenuSubItemText = styled(MenuItemText)`
  font-size: 1.2rem;
`;

const IconSize = '2.25rem';

export const Icon = styled.div`
  color: inherit;
  width: ${IconSize};
  height: ${IconSize};
  svg {
    width: ${IconSize};
    height: ${IconSize};
    color: inherit;
  }
`;

export const LogoutIconButton = styled(Icon)`
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
  color: ${(p) =>
    calculateSafeColorInsideContainer(
      p.theme.seller.primary.safeColorInsideContainer
    )};
`.withComponent('button');

export const NavToggleIconButton = styled(Icon)`
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0.8rem 0.8rem;
  margin-right: 0.75rem;
  margin-left: auto;
  color: ${(p) => p.theme.seller.primary.safeColorInsideContainer};
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`.withComponent('button');

export const UserCard = styled.div`
  background-color: ${(p) => p.theme.seller.primary.safeColorInsideContainer};
  border-radius: 0.5rem;
  padding: 0 0.8rem;
  margin: 0 0.75rem;
  height: 5rem;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const UserName = styled.h1`
  margin: 0;
  font-size: 1.6rem;
  font-weight: bold;
  white-space: nowrap;

  color: ${(p) => p.theme.seller.primary.value};
`;

export const UserCardInformation = styled.div`
  flex: 1;
  overflow: hidden;

  display: flex;
  flex-direction: column;
`;

export const UserEmail = styled.p`
  margin: 0;
  font-size: 1.4rem;
  font-weight: 500;
  white-space: nowrap;
  color: ${(p) =>
    calculateSafeColorInsideContainer(
      p.theme.seller.primary.safeColorInsideContainer
    )};
`;

export const Logo = styled(animated.div)`
  padding: 0 0.8rem;
  margin: 0 0.75rem;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.theme.seller.logo_bg};
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
`;

export const LogoImg = styled(animated.img)`
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
`;

export const SelectorContainer = styled(animated.div)`
  padding: 0 0.8rem;
`;

export const PopoverContent = styled.div`
  background-color: ${(p) => p.theme.bg};

  ${Links} {
    padding-left: 0;
  }
  ${MenuItem} {
    padding: 1rem 2rem;
    color: ${(p) => p.theme.gray[400]};
    ${MenuSubItemText} {
      font-size: 1.4rem;
    }
  }
`;
